module.exports = __webpack_public_path__ + "static/person-1-70x70-f77e2e70d375b955475b94c6b2a6aaef.png";